
import React from 'react'
import { withStyles, createStyles } from '@mui/styles'
import Grid from '@mui/material/Grid'
import TeamAndRecords from './TeamAndRecords'
import SimpleScores from 'smartstream-widgets/controls/SimpleScores/SimpleScores'

import { Scoreboard } from './types'

const styles = () => createStyles({
  root: {},
  liveScoreClass: {
    fontSize: 20,
    lineHeight: 1.2
  },
  teamName: {
    fontWeight: 'bold'
  },
  teamNameContainer: {
    flex: '1',
    maxWidth: '40%'
  }
})

export function ScoreboardAndRecords (props: Scoreboard) {
  const {
    leftTeam,
    rightTeam,
    liveScore,
    isLive,
    hideLiveScore = false,
    classes: {root, liveScoreClass, teamName, teamNameContainer}
  } = props

  return (
    <Grid container
      justifyContent='space-between'
      wrap='nowrap'
      alignItems='center'
      className={root} 
      data-testid="scoreboard-and-records-container">
      <TeamAndRecords classes={{teamName, root: teamNameContainer}} {...leftTeam} teamSide='left' />
      {!hideLiveScore && isLive && <SimpleScores classes={{root: liveScoreClass}} {...liveScore} animationType={'slideUp'} />}
      <TeamAndRecords classes={{teamName, root: teamNameContainer}} {...rightTeam} teamSide='right' />
    </Grid>
  )
}

export default withStyles(styles, { name : 'ScoreboardAndRecords'})(ScoreboardAndRecords)
